export const SET_MODIFICATION_MODE = 'SET_MODIFICATION_MODE' as const;
export const setModificationMode = (modificationMode: boolean) => ({
  type: SET_MODIFICATION_MODE,
  modificationMode,
});

export type SetModificationMode = ReturnType<typeof setModificationMode>;

export type MessageDetailsActions = SetModificationMode;
